import { computed, ref } from 'vue'
import { ID_DAS_NOVIDADES } from '@/constants/novidades.js'

const CHAVE = 'novidades-lidas'

// Estado de módulo: o cabeçalho remonta a cada troca de layout, e o pontinho tem que
// continuar apagado depois de lido.
const idLido = ref(lerIdLido())

function lerIdLido() {
  try {
    return localStorage.getItem(CHAVE)
  } catch {
    // Navegação privada ou armazenamento bloqueado. Sem memória, o aviso volta a aparecer
    // a cada visita — chato, mas melhor do que quebrar o cabeçalho.
    return null
  }
}

/**
 * Aviso de novidades do cabeçalho.
 *
 * O pontinho aparece enquanto a leva atual não foi aberta. Trocar o ID_DAS_NOVIDADES faz
 * ele voltar para todo mundo, o que é o único jeito de anunciar a leva seguinte.
 */
export function useNovidades() {
  const temNovidade = computed(() => idLido.value !== ID_DAS_NOVIDADES)

  const marcarComoLidas = () => {
    idLido.value = ID_DAS_NOVIDADES

    try {
      localStorage.setItem(CHAVE, ID_DAS_NOVIDADES)
    } catch {
      // Não conseguir lembrar não impede de apagar o pontinho nesta sessão
    }
  }

  return { temNovidade, marcarComoLidas }
}

// Exportado para os testes conseguirem partir de um estado limpo
export function _recarregarIdLido() {
  idLido.value = lerIdLido()
}
